import React, { FC, memo } from 'react'
import { FluidImage, HStack } from '../index'
import { PhoneSpecs as Phone } from '../../phones'
import { PhoneSpecs } from './phone-specs'
import { Center } from '@chakra-ui/react'
import i18next from 'i18next'

export interface PhoneCardProps {
  phone: Phone
  onClick: (modelId: Phone['modelId']) => void
}

const translateMemory = (memoryName: string) => {
  const data = memoryName.match(/(?<dataValue>\d+)(\s)?(?<dataUnit>MB|GB|TB)/i)
  if (data?.groups?.dataUnit && data?.groups?.dataValue) {
    const translatedUnit = i18next.t(`common_${data?.groups?.dataUnit}`)
    memoryName = `${data?.groups?.dataValue} ${translatedUnit}`
  }

  return memoryName
}
const managePressedKey =
  (onClick: { (modelId: number): void; (arg0: any): void }, modelId: number) => (e: { key: string }) => {
    if (e.key === 'Enter') {
      onClick(modelId)
    }
  }

/**
 * There should probably be a more generic "card" component, but I can't see a pattern, plus, some cards in the UI
 * have a hover state and others don't. This one requires a label, others don't. Can't see the pattern yet, so this
 * guy is split for readability purposes in <PhoneList />.
 */
export const PhoneCard: FC<PhoneCardProps> = memo(({ phone, onClick }) => {
  return (
    <HStack
      role="button"
      aria-label={phone.name}
      width="full"
      maxWidth={290}
      maxHeight={120}
      borderRadius="default"
      justifyContent="space-between"
      padding={4}
      marginBottom={4}
      border={2}
      borderStyle="solid"
      borderColor="grey"
      userSelect="none"
      cursor="pointer"
      marginX={1}
      _hover={{
        borderColor: 'brand',
      }}
      label={phone.name}
      onClick={() => onClick(phone.modelId)}
      onKeyPress={managePressedKey(onClick, phone.modelId)}
      position="relative"
      _focus={{
        borderColor: 'brand',
        boxShadow: '0 0 0 3px #5bce4c',
      }}
      tabIndex={0}
    >
      <Center width={20} height={20}>
        <FluidImage src={`https://www.planhub.ca/img/phone/${phone.slug}.png`} alt={phone.name} />
      </Center>
      <PhoneSpecs name={phone.name} brand={phone.brandName} memory={translateMemory(phone.modelMemoryName)} />
    </HStack>
  )
})
